// extracted by mini-css-extract-plugin
export default {"container":"Products_container__apgdm","products":"Products_products__1Jk3P","menu":"Products_menu__5Ff0t","list":"Products_list__+QUtt","product":"Products_product__Xos6v"};